<div *ngIf="displayMode==2 && scope">
  <div class="scope-note">
    <p class="text-muted no-margin" *ngIf="isCompany">
      Company default: applies to every business unit and user without working days of their own.
    </p>
    <p class="text-muted no-margin" *ngIf="businessUnitId && !scope.hasOwnRule">
      {{scope.businessUnitName}} has no working days of its own; the days below are inherited. Changing or rearranging a day gives it (and its sub-units) its own week.
    </p>
    <p class="text-muted no-margin" *ngIf="businessUnitId && scope.hasOwnRule">
      {{scope.businessUnitName}} has its own working days; its sub-units follow them unless they have their own.
    </p>
    <p class="text-muted no-margin" *ngIf="userId">
      <span *ngIf="scope.userBusinessUnitName">Business unit: <b>{{scope.userBusinessUnitName}}</b>. </span>
      <span *ngIf="!scope.hasOwnRule">No exception: the user follows the days below. Changing or rearranging a day creates a user exception.</span>
      <span *ngIf="scope.hasOwnRule">This user has an exception.</span>
    </p>
    <p class="text-muted no-margin" *ngIf="allowReorder && canManage">Drag rows to arrange the week; the first day starts the week.</p>
    <p class="text-muted no-margin" *ngIf="canManage">Changes apply from today; earlier dates and reports keep the previous days.</p>
  </div>

  <table class="table">
    <thead>
      <tr>
        <th width="5%" *ngIf="allowReorder && canManage"></th>
        <th>{{'app.name' | translate}}</th>
        <th width="12%">Am</th>
        <th width="12%">Pm</th>
        <th *ngIf="!isCompany">Source</th>
      </tr>
    </thead>
    <tbody cdkDropList [cdkDropListDisabled]="!allowReorder || !canManage" (cdkDropListDropped)="drop($event)">
      <tr *ngFor="let workingDay of days" cdkDrag>
        <td class="drag-handle" cdkDragHandle *ngIf="allowReorder && canManage"><i class="fa fa-bars"></i></td>
        <td>{{ workingDay.name }}</td>
        <td>
          <label class="switch">
            <input type="checkbox" [checked]="workingDay.amActive" [disabled]="!canManage" (click)="toggle(workingDay, true)">
            <span class="slider round"></span>
          </label>
        </td>
        <td>
          <label class="switch">
            <input type="checkbox" [checked]="workingDay.pmActive" [disabled]="!canManage" (click)="toggle(workingDay, false)">
            <span class="slider round"></span>
          </label>
        </td>
        <td *ngIf="!isCompany" class="source">{{ sourceLabel(workingDay) }}</td>
      </tr>
      <tr *ngIf="days.length==0">
        <td colspan="5">{{'app.NoDataFound' | translate}}</td>
      </tr>
    </tbody>
  </table>

  <button type="button" class="btn btn-default btn-sm" *ngIf="canManage && !isCompany && scope.hasOwnRule" (click)="confirmReset()">
    <i class="fa fa-undo"></i>&nbsp;{{ userId ? 'Remove user exception' : 'Remove own working days' }}
  </button>
</div>

<div class="history-section" *ngIf="displayMode==2 && scope">
  <button type="button" class="btn btn-link btn-sm no-padding" (click)="toggleHistory()">
    <i class="fa" [class.fa-history]="!showHistory" [class.fa-chevron-up]="showHistory"></i>&nbsp;{{ showHistory ? 'Hide history' : 'History by month' }}
  </button>

  <div *ngIf="showHistory" class="history-body">
    <div class="history-picker">
      <select class="form-control input-sm" [(ngModel)]="historyMonth" (ngModelChange)="loadHistory()">
        <option *ngFor="let m of monthNames; let i = index" [ngValue]="i + 1">{{m}}</option>
      </select>
      <select class="form-control input-sm" [(ngModel)]="historyYear" (ngModelChange)="loadHistory()">
        <option *ngFor="let y of historyYears" [ngValue]="y">{{y}}</option>
      </select>
    </div>

    <div class="text-center" *ngIf="historyLoading"><i class="fa fa-spinner fa-spin"></i></div>

    <ng-container *ngIf="history && !historyLoading">
      <div class="history-summary">
        <b>{{monthNames[history.month - 1]}} {{history.year}}</b><span *ngIf="history.name"> &middot; {{history.name}}</span><br />
        Working days: <b>{{history.workingDaysTotal}}</b> (AM {{history.workingDaysAm}} &middot; PM {{history.workingDaysPm}})
        &middot; Off days: <b>{{history.offDays}}</b>
        <span *ngIf="history.holidays.length"> &middot; Holidays:
          <span *ngFor="let h of history.holidays; let last = last">{{h.name}} ({{h.startDate | date:'d MMM'}}<span *ngIf="h.endDate !== h.startDate"> &ndash; {{h.endDate | date:'d MMM'}}</span>)<span *ngIf="!last">, </span></span>
        </span>
      </div>

      <div class="history-period" *ngFor="let period of history.periods">
        <div class="history-period-title">
          {{period.from | date:'d MMM'}} &ndash; {{period.to | date:'d MMM yyyy'}}
          <span *ngIf="period.businessUnitName"> &middot; Business unit: {{period.businessUnitName}}</span>
          <span *ngIf="history.periods.length > 1" class="label label-warning">changed during the month</span>
        </div>
        <table class="table table-condensed">
          <thead>
            <tr><th>{{'app.name' | translate}}</th><th width="15%">Am</th><th width="15%">Pm</th><th>Source</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let day of period.days" [class.history-off]="!day.amActive && !day.pmActive">
              <td>{{day.name}}</td>
              <td>{{day.amActive ? 'Yes' : 'Off'}}</td>
              <td>{{day.pmActive ? 'Yes' : 'Off'}}</td>
              <td class="source">{{historySourceLabel(day)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </div>
</div>

<div class="text-center" *ngIf="displayMode==1">
  <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i>
  <p>{{'app.Loading' | translate}}</p>
</div>
<div class="alert alert-danger alert-dark" *ngIf="displayMode==3">
  {{'app.ServerError' |translate}}.
</div>
